module.exports = __webpack_public_path__ + "18f90631094e798fb9f909812e1d86b8.svg";